import React from 'react'

export const useHostConfiguration = (
  voices: Array<{ id: string; name?: string | null }>,
  hostAVoiceId?: string,
  hostBVoiceId?: string
) => {
  // Resolve display names for A/B
  const hostLabels = React.useMemo(() => {
    const findName = (id?: string) => (voices.find(v => v.id === id)?.name || '').trim()
    const aName = findName(hostAVoiceId) || 'Host A'
    const bName = findName(hostBVoiceId) || 'Host B'
    return { A: aName, B: bName } as Record<string, string>
  }, [voices, hostAVoiceId, hostBVoiceId])

  // Enforce distinct colors for A vs B
  const hostColors = React.useMemo(() => ({
    A: 'bg-blue-100 text-blue-800 ring-blue-600/20',
    B: 'bg-amber-100 text-amber-800 ring-amber-600/20',
  } as Record<string, string>), [])

  return { hostLabels, hostColors }
}
